"use client"
import React, { Component } from "react"
import { Mic, Stop } from "@material-ui/icons"
import { CircularProgress } from "@material-ui/core";

export default class UserVoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isListening: false,
      isTranscribing: false,
      mediaRecorder: null,
      audioChunks: [],
    };
    // Add cleanup references
    this.transcriptionController = null
    // VOICE MODE: Long press detection
    this.longPressTimer = null
    this.isLongPress = false
  }

  componentWillUnmount() {
    this.stopListening();
    // Abort any pending transcription requests
    if (this.transcriptionController) { this.transcriptionController.abort(); }
    // VOICE MODE: Clear long press timer
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer)
    }
  }
  
  // VOICE MODE: Handle long press to enter voice mode
  handleMouseDown = () => {
    console.log('[LongPress] mouseDown / touchStart — starting 800ms timer')
    this.isLongPress = false
    this.longPressTimer = setTimeout(() => {
      console.log('[LongPress] 800ms reached → firing onEnterVoiceMode', !!this.props.onEnterVoiceMode)
      this.isLongPress = true
      // Trigger voice mode if prop is available
      if (this.props.onEnterVoiceMode) {
        this.props.onEnterVoiceMode()
      }
    }, 800) // 800ms for long press
  }

  // VOICE MODE: Clear long press timer on mouse up
  handleMouseUp = () => {
    console.log('[LongPress] mouseUp / touchEnd — isLongPress=', this.isLongPress)
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer)
    }
    // If it wasn't a long press, do normal click action
    if (!this.isLongPress) {
      // Normal click behavior handled by onClick
    }
    this.isLongPress = false
  }
  
  // VOICE MODE: Handle click (only if not long press)
  handleClick = () => {
    if (!this.isLongPress) {
      this.startListening()
    }
  }
  startListening2 = async () => {
    try {
      if (this.props.stopAudio) {
        this.props.stopAudio();
      }
      if (this.props.unlockAudioPlayback) {
        this.props.unlockAudioPlayback();
      }
      this.setState({ isListening: true })
      const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true},})

      const mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/webm;codecs=opus"})
      const audioChunks = [];

      mediaRecorder.addEventListener("dataavailable", (event) => {
        if (event.data.size > 0) { audioChunks.push(event.data);}
      });

      mediaRecorder.addEventListener("stop", async () => {
        // Only process if we have meaningful audio data
        if (audioChunks.length > 0) {
          const audioBlob = new Blob(audioChunks, { type: "audio/webm" })
          // Check if audio has meaningful size more than just silence
          if (audioBlob.size > 1000) {
            this.setState({ isTranscribing: true });  //  show spinner
            await this.sendAudioToBackend(audioBlob);
            this.setState({ isTranscribing: false }); //  hide spinner
          }}
        // Clean up stream
        stream.getTracks().forEach((track) => track.stop());
      });

      mediaRecorder.start();

      this.setState({
        mediaRecorder,
        audioChunks,
      });

    } catch (err) {
      console.error("Error accessing microphone:", err);
      // Reset UI state on error
      this.setState({ isListening: false })
      if (err.name === "NotAllowedError") {
        alert("Microphone access denied. Please allow microphone access and try again.")
      } else {
        alert("Microphone access denied or not available")};
    }
  };

  startListening = async () => {
  try {
    if (this.props.stopAudio) {
      this.props.stopAudio();
    }
    if (this.props.unlockAudioPlayback) {
      this.props.unlockAudioPlayback();
    }

    this.setState({ isListening: true });

    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      },
    });

    const mediaRecorder = new MediaRecorder(stream, {
      mimeType: "audio/webm;codecs=opus",
    });

    const audioChunks = [];
    mediaRecorder.addEventListener("dataavailable", (event) => {
      if (event.data.size > 0) audioChunks.push(event.data);
    });

    mediaRecorder.addEventListener("stop", async () => {
      if (audioChunks.length > 0) {
        const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
        if (audioBlob.size > 1000) {
          this.setState({ isTranscribing: true });
          await this.sendAudioToBackend(audioBlob);
          this.setState({ isTranscribing: false });
        }
      }
      stream.getTracks().forEach((track) => track.stop());
    });

    // 🎯 Setup silence detection
    const audioContext = new AudioContext();
    const source = audioContext.createMediaStreamSource(stream);
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 2048;
    source.connect(analyser);

    const buffer = new Float32Array(analyser.fftSize);
    let silenceStart = null;
    const silenceDuration = 2000; // 2 seconds of silence
    const silenceThreshold = 0.02; // adjust for noise sensitivity

    const checkSilence = () => {
      analyser.getFloatTimeDomainData(buffer);
      const rms = Math.sqrt(
        buffer.reduce((sum, val) => sum + val * val, 0) / buffer.length
      );

      if (rms < silenceThreshold) {
        if (!silenceStart) silenceStart = Date.now();
        else if (Date.now() - silenceStart > silenceDuration) {
          console.log("Silence detected → auto-stop recording");
          this.stopListening(); // triggers stop event + upload
          return;
        }
      } else {
        silenceStart = null; // reset timer if speech resumes
      }

      if (this.state.isListening) {
        requestAnimationFrame(checkSilence);
      }
    };

    // Start both recording and silence monitoring
    mediaRecorder.start();
    requestAnimationFrame(checkSilence);

    this.setState({ mediaRecorder, audioChunks });
  } catch (err) {
    console.error("Error accessing microphone:", err);
    this.setState({ isListening: false });
    if (err.name === "NotAllowedError") {
      alert("Microphone access denied. Please allow microphone access and try again.");
    } else {
      alert("Microphone access denied or not available");
    }
  }
};

  stopListening = () => {
    const { mediaRecorder } = this.state;
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
    }
    this.setState({ isListening: false });
  };

  sendAudioToBackend = async (audioBlob) => {
    try {
      // Create abort controller for cleanup
      this.transcriptionController = new AbortController()
      const formData = new FormData();
      formData.append("file", audioBlob, "recording.webm");

      const response = await fetch(`${this.props.host}/api/v1/tts/stt`, {
        method: "POST",
        body: formData,
        signal: this.transcriptionController.signal,})

      if (!response.ok) {
        throw new Error("Transcription failed");
      }

      const data = await response.json();
      // Filter out garbage text before sending to input
      if (data.text && this.isValidTranscription(data.text)) {
        this.props.onTranscript(data.text);
      }
      // If invalid, just don't send anything - no error messages
    } catch (error) {
      if (error.name === "AbortError") {
        return // Request was cancelled, ignore
      }
      console.error("Error sending audio to backend:", error)
    } finally {
      this.transcriptionController = null
    }
  }
  // Smart garbage text filtering
  isValidTranscription = (text) => {
    if (!text || typeof text !== "string") {
      return false
    }

    const cleanText = text.trim().toLowerCase()

    // Filter out common garbage phrases
    const garbagePhrases = [
      "thanks for watching",
      "thank you for watching",
      "subscribe",
      "like and subscribe",
      "please subscribe",
      "hit the bell",
      "see you next time",
      "bye bye",
      "goodbye",
      "music",
      "[music]",
      "applause",
      "[applause]",
      "laughter",
      "[laughter]",
      "silence",
      "quiet",
    ]

    // Check if text is too short (likely just noise)
    // if (cleanText.length < 2) {
    //   return false
    // }

    // Check if text is mostly garbage phrases
    // const containsGarbage = garbagePhrases.some(
    //   (phrase) => cleanText.includes(phrase) && cleanText.length < phrase.length + 5,
    // )

    // Check if text is mostly real words (not just noise like "uh", "um")
    const alphanumericCount = (cleanText.match(/[a-z0-9]/g) || []).length
    const isMainlyText = alphanumericCount / cleanText.length > 0.6

    return isMainlyText
  }

  renderWaveform = () => (
    <div className="wave cb-voice-wave-bars" aria-hidden="true">
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
    </div>
  );

  render() {
    const { isListening, isTranscribing } = this.state;
    // REDESIGN: Support inline mode via props for cleaner integration
    const inlineMode = this.props.inline !== false; // Default to inline

    // REDESIGN: Inline compact styles for input bar integration
    const inlineButtonStyle = {
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      transition: 'background 0.2s ease'
    };

    const inlineContainerStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      gap: '6px'
    };

    if (inlineMode) {
      // REDESIGN: Render compact inline version with wave animation when recording
      return (
        <div style={inlineContainerStyle}>
          {isTranscribing ? (
            <CircularProgress size={20} style={{ color: '#8b5cf6' }} />
          ) : isListening ? (
            <>
              {/* REDESIGN: Show mini wave animation while recording */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                marginRight: '4px'
              }}>
                {[1, 2, 3, 4].map((bar) => (
                  <div
                    key={bar}
                    style={{
                      width: '3px',
                      height: '16px',
                      background: '#8b5cf6',
                      borderRadius: '2px',
                      animation: `waveAnimation 1s ease-in-out infinite`,
                      animationDelay: `${bar * 0.1}s`
                    }}
                  />
                ))}
              </div>
              <button
                type="button"
                onClick={this.stopListening}
                aria-label="Stop recording"
                style={{...inlineButtonStyle, color: '#f44336'}}
              >
                <Stop style={{fontSize: '24px'}} />
              </button>
            </>
          ) : (
            <button
              type="button"
              onClick={this.handleClick}
              onMouseDown={this.handleMouseDown}
              onMouseUp={this.handleMouseUp}
              onTouchStart={this.handleMouseDown}
              onTouchEnd={this.handleMouseUp}
              aria-label="Start voice input (long press for voice mode)"
              style={{...inlineButtonStyle, color: '#5f6368'}}
              title="Tap: record message | Long press: enter voice mode"
            >
              <Mic style={{fontSize: '24px'}} />
            </button>
          )}
        </div>
      );
    }

    // Original floating button mode (kept for backward compatibility)
    return (
      <div
        className={[
          'cb-voice-recorder',
          isListening ? 'cb-voice-recorder--listening' : '',
          isTranscribing ? 'cb-voice-recorder--transcribing' : '',
        ].filter(Boolean).join(' ')}
      >
        {isTranscribing ? (
          <div className="cb-voice-transcribing">
            <CircularProgress size={32} style={{ color: '#1f8ded' }} />
            <span className="cb-voice-transcribing-label">Transcribing…</span>
          </div>
        ) : isListening ? (
          <>
            <div className="cb-voice-wave">{this.renderWaveform()}</div>
            <button
              type="button"
              className="cb-mic-btn cb-mic-btn--recording"
              onClick={this.stopListening}
              aria-label="Stop recording"
            >
              <Stop />
            </button>
            <span className="cb-voice-hint">Tap to stop</span>
          </>
        ) : (
          <button
            type="button"
            className="cb-mic-btn"
            onClick={this.startListening}
            aria-label="Start voice input"
          >
            <Mic />
          </button>
        )}
      </div>
    );
  }
}

